import {
    allVariants,
    collection,
    parentTypeFor,
    refs,
    routePath,
} from "../_variants/index.js";
import { countByReason, reasonByResolution, resolvedStatus, trendOverTime } from "./chartConfigs.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import { appConfig } from "../../../utils.js";
import effectivitiesAttachable from "../Effectivities/attachable.js";
import { makeDocumentsAttachable } from "../Documents/attachable.js";
import { makeDrawingAttachable } from "../Drawings/attachable.js";
import { makeServiceBulletinAttachable } from "../ServiceBulletins/attachable.js";
import { signoffDQN } from "./actions.js";
import { time } from "../../standardAttachables";

const ItemAnalyticsView = () => import("../../../components/ItemAnalyticsView/ItemAnalyticsView.vue");

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}, {
    "label": "Is Resolved?",
    compute( { item } ) {
        return `<span class="font-bold ${item.Signedoff ? 'text-green' : 'text-red'}">${item.Signedoff ? 'Resolved' : 'Unresolved'}</span>`
    }
}, {
    "label": "Reason",
    "key": "Reason"
},{
    "label": "Comment",
    "key": "Comment",
    "class": "md:col-span-3"
}];

const menuActions = [{
    "label": "Resolve DQN",
    "action": signoffDQN,
    "show": ({ item }) => {
        return [!item.Signedoff, "This DQN is already resolved"];
    }
}];

/**
 * Build the list + detail vue-router routes for the DQN register matching
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeDQNRoutes = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military DQN" : "DQN";
    const labelPlural = isMilitary ? "Military DQNs" : "DQNs";
    const dqnParentType = parentTypeFor(variant, "DQNs");
    const listPath = routePath(variant, "DQNs");

    const analyticsPath = `${listPath}/analytics`;

    return [{
        "path": listPath,
        "component": {...ItemListView},
        "name": labelPlural,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "sideNav": true,
            "sideNavSection": "Design Items",
            "analyticsRoute": true,
            "appSwitcher": false,
            "icon": variant.appIcon,
            "tableSettings": dqnParentType,
            "dataPath": refs(variant, "DQNs"),
            ...(appConfig.useElasticsearchLists && variant.collectionPrefix === "" ? { "esType": "DQNs" } : {}),
            "selectionRoute": `Database/${dqnParentType}/{ID}`,
            "analyticsRoute": analyticsPath,
        }
    }, {
        "path": analyticsPath,
        "component": ItemAnalyticsView,
        "name": `${labelPlural} Analytics`,
        "meta": {
            "app": variant.app,
            "sideNav": false,
            "analyticsTitle": `${labelPlural} Analytics`,
            "dataPath": refs(variant, "DQNs"),
            "listRoute": listPath,
            "options": {
                countByReason,
                resolvedStatus,
                trendOverTime,
                reasonByResolution,
            },
        }
    }, {
        "path": `${listPath}/:id`,
        "component": ItemView,
        "name": labelSingular,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "dataPath": collection(variant, "DQNs"),
            "selectionRoute": `Database/${dqnParentType}/{ID}`,
            title(item) {
                return `${labelPlural}: ${item.Number}`
            },
            "attachedItems": {
                "Attached Items": {
                    "attachables": [makeDocumentsAttachable(variant), makeDrawingAttachable(variant), effectivitiesAttachable, makeServiceBulletinAttachable(variant)]
                },
                "Additional Information": {
                    "attachables": [time]
                }
            },
            "preventAttachedItemsActions": false,
            "preventAttachedItemsRowActions": false,
            "dataFields": dataFields,
            "menuActions": menuActions,
            "formMetadata": {
                "ParentType": dqnParentType
            }
        }
    }];
};

export default allVariants().flatMap(makeDQNRoutes);
